export const DUMMY_ZONE_NAME = 'No Zone'
